export const imageUpload = {
	addImage: "Añadir imagen",
	removeImage: "Eliminar imagen cargada",
	formatInfo: "JPG o PNG",
	ariaLabel: {
		uploadedImage: "Imagen del producto cargada",
	},
};
